import React, { useEffect, useRef, useState } from 'react';
import Answer from './component/Answer';
import TabSelector from '../TabSelector/TabSelector';
import './CodingComponent.css';

import { codingData } from "../codingData/codingData";

const CodingComponent = () => {
  const [activeTab, setActiveTab] = useState(codingData[0].id);
  const [isHovered, setIsHovered] = useState(false);
  const leftSideRef = useRef(null);
  const rightSideRef = useRef(null);
  const [answerKey, setAnswerKey] = useState(0);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setAnswerKey(prevKey => prevKey + 1); // Increment key to force remount
  };

  const activeContent = codingData.find((tab) => tab.id === activeTab);

  useEffect(() => {
    const handleResize = () => {
      if (leftSideRef.current && rightSideRef.current) {
        const rightWidth = rightSideRef.current.offsetWidth;
        leftSideRef.current.style.setProperty('--hovered-width', `${rightWidth}px`);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="coding-component">
      <TabSelector tabs={codingData} activeTab={activeTab} onTabChange={handleTabChange} />

      <div className="coding-content-section">
        <div
          ref={leftSideRef}
          className={`coding-left-side ${isHovered ? 'hovered' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img
            src={activeContent.image}
            alt={`${activeContent.label} Question`}
          />
        </div>
        <div ref={rightSideRef} className="coding-right-side">
        <Answer content={activeContent.content} key={answerKey} />
        </div>
      </div>
    </div>
  );
};

export default CodingComponent;
